import Axios from 'axios'

export default {
    state: {
        trainingHistory: null
    },
    getters: {
        trainingHistory(state) {
            return state.trainingHistory
        },
    },
    mutations: {
        setTrainingHistory(state, payload) {
            state.trainingHistory = payload
        }
    },
    actions: {
        getTrainingHistory: async ({ commit, getters }) => {
            commit('setLoading')
            await Axios.get(`${process.env.VUE_APP_API_URL_TRAINING_HISTORY}${getters.user._id}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + localStorage.getItem('token')
                }
            })
                .then(res => {
                    commit('setLoading')
                    if (res.data.status != 200) {
                        res.data = []
                        throw new Error(res.data.message)
                    }
                    commit('setTrainingHistory', res.data.data)
                }
                ).catch(error => {
                    commit('setTrainingHistory', {})

                })
        },
        saveMeasurments: async ({ commit, getters }, payload) => {
            commit('setLoading')
            await Axios.post(process.env.VUE_APP_API_URL_TRAINING_HISTORY, { user: getters.user._id, musclesMeasurements: payload }, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + localStorage.getItem('token')
                }
            })
                .then(res => {
                    commit('setLoading')
                    if (res.request.status != 200) {
                        res.data = []
                        throw new Error(res.data.message)
                    }
                    commit('setTrainingHistory', res.data.data)
                }
                ).catch(error => {
                })
        },
        async saveImc({ commit, getters }, payload) {
            commit('setLoading')
            await Axios.post(process.env.VUE_APP_API_URL_TRAINING_HISTORY,
                { ...payload, user: getters.user._id, birthday: getters.user.birthday, gender: getters.user.gender },
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + localStorage.getItem('token')
                    }
                })
                .then(async res => {
                }
                ).catch(error => {
                    commit('clearSnackAlert')
                    commit('setSnackAlert', {
                        status: true,
                        success: false,
                        error: true,
                        message: '<strong>Erreur:</strong> ' + error.message
                    })
                    commit('setLoading')
                    commit('clearError')
                    commit('setError', error)
                })
        }
    },
}
